import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

export function scrollToId(id) {
  if (window.__lenis) {
    window.__lenis.scrollTo(id, { offset: -80, duration: 1.4 });
  } else {
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  }
}
